
export const shopWrappedData = [
    {
        title: "Notion Scroll: ACT I",
        features: [
            "12 Sales in 2025",
            "45 Total Visits",
            "26.6% Conversion Rate",
            "Best performing story arc"
        ],
        readMore: "shop.vlad.chat/l/hidden-truths"
    },
    {
        title: "Learned Helplessness",
        features: [
            "7 Sales in 2025",
            "39 Total Visits",
            "17.9% Conversion Rate",
            "Psychology & Productivity"
        ],
        readMore: "shop.vlad.chat/l/help"
    },
    {
        title: "Emotional Trading",
        features: [
            "8 Sales in 2025",
            "55 Total Visits",
            "14.5% Conversion Rate",
            "Psychology of markets"
        ],
        readMore: "shop.vlad.chat/l/trading"
    }
];
